// HACK: Manually define types for import.meta.env as vite/client types seem unavailable in this environment.
// FIX: To solve "Property 'env' does not exist on type 'ImportMeta'", the manual type definitions for `import.meta.env` are wrapped in `declare global` to correctly augment the global interface from within a module.
// FIX: The original declaration for `ImportMeta` was conflicting with Vite's client types.
// This now correctly augments the `ImportMetaEnv` interface to avoid type conflicts.
declare global {
  interface ImportMetaEnv {
    readonly VITE_MOCK_API: string;
  }
}

import { mockApi } from './mockApi';

let isRefreshing = false;
let refreshPromise: Promise<Response> | null = null;

async function fetchRequest<T>(url: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(url, options);

    if (!response.ok) {
        if (response.status === 401 && url !== '/auth/refresh') {
            if (!isRefreshing) {
                isRefreshing = true;
                refreshPromise = fetch('/auth/refresh', { method: 'POST', credentials: 'include' });
            }
            
            const refreshResponse = await refreshPromise;
            isRefreshing = false;
            
            if (refreshResponse.ok) {
                return fetchRequest<T>(url, options);
            }
        }
        
        const errorData = await response.json().catch(() => ({ message: 'Ocorreu um erro desconhecido' }));
        const error = new Error(errorData.message || response.statusText);
        throw error;
    }

    if (response.status === 204) {
        return null as T;
    }
    
    return response.json();
}

const realHttp = {
    get: <T>(url: string, options?: RequestInit) => fetchRequest<T>(url, { ...options, method: 'GET', credentials: 'include' }),
    post: <T>(url: string, body?: any, options?: RequestInit) => {
        const config: RequestInit = {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(body),
            credentials: 'include',
        };
        return fetchRequest<T>(url, config);
    },
    put: <T>(url: string, body?: any, options?: RequestInit) => {
         const config: RequestInit = {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(body),
            credentials: 'include',
        };
        return fetchRequest<T>(url, config);
    },
};

const mockHttp = {
    get: <T>(url: string): Promise<T> => {
        if (url === '/auth/session') return mockApi.getSession() as Promise<T>;
        if (url === '/api/beneficiarios') return mockApi.getBeneficiarios() as Promise<T>;
        if (url.startsWith('/api/seguranca')) return mockApi.getSecurityData(url) as Promise<T>;
        if (url.startsWith('/api/localizacao')) return mockApi.getLocationData(url) as Promise<T>;
        throw new Error(`Mock GET for ${url} not implemented.`);
    },
    post: <T>(url: string, body?: any): Promise<T> => {
        if (url === '/auth/login') return mockApi.login(body.email, body.password) as Promise<T>;
        if (url === '/auth/logout') return mockApi.logout() as Promise<T>;
        throw new Error(`Mock POST for ${url} not implemented.`);
    },
    put: <T>(url: string, body?: any): Promise<T> => {
        if (url === '/api/beneficiarios') return mockApi.updateBeneficiary(body) as Promise<T>;
        if (url.startsWith('/api/seguranca')) return mockApi.updateSecurityData(url, body) as Promise<T>;
        throw new Error(`Mock PUT for ${url} not implemented.`);
    },
};

export const http = import.meta.env.VITE_MOCK_API === 'true' ? mockHttp : realHttp;